import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TopBar from '../../components/TopBar'
import { useAnalytics } from '../../context/AnalyticsContext'
import { getOnboarding, setOnboarding } from './onboardingStorage'
import './onboarding.css'

const SECTIONS = [
  { titleKey: 'onboarding.interestsSectionLifestyle', itemKeys: ['deepTalks', 'humor', 'personalGrowth', 'mindfulness', 'spirituality', 'lateNights', 'earlyMornings'] },
  { titleKey: 'onboarding.interestsSectionDating', itemKeys: ['meaningfulConnections', 'flirting', 'emotionalCloseness', 'slowDating', 'instantChemistry'] },
  { titleKey: 'onboarding.interestsSectionCulture', itemKeys: ['music', 'moviesSeries', 'artDesign', 'reading', 'photography'] },
  { titleKey: 'onboarding.interestsSectionActivities', itemKeys: ['traveling', 'walking', 'sportsFitness', 'yoga', 'dancing'] }
]

const OnboardingInterests = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const [selected, setSelected] = useState([])

  useEffect(() => {
    const saved = getOnboarding()
    if (Array.isArray(saved.interests)) setSelected(saved.interests)
  }, [])

  const onBack = () => navigate('/onboarding/birth')

  const toggle = (key) => {
    setSelected((prev) => {
      const next = prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
      setOnboarding({ interests: next })
      return next
    })
  }

  const onContinue = () => {
    setOnboarding({ interests: selected })
    trackEvent('funnel_interests_completed', { step: 4, count: selected.length })
    navigate('/onboarding/looking-for')
  }

  return (
    <div className="onboarding-page">
      <TopBar currentStep={4} totalSteps={10} onBack={onBack} showBack={true} />
      <div className="onboarding-content">
        <h1 className="h1">{t('onboarding.interestsTitle')}</h1>
        <p className="p">{t('onboarding.interestsSubtitle')}</p>

        {SECTIONS.map((s) => (
          <div key={s.titleKey} className="field">
            <div className="label">{t(s.titleKey)}</div>
            <div className="chips">
              {s.itemKeys.map((key) => (
                <button
                  key={key}
                  className={`chip ${selected.includes(key) ? 'active' : ''}`}
                  onClick={() => toggle(key)}
                  aria-pressed={selected.includes(key)}
                >
                  {t('onboarding.interestsItems.' + key)}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button className="cta-fixed" onClick={onContinue}>
        {t('common.continue')}
      </button>
    </div>
  )
}

export default OnboardingInterests

